export default {"src":"/_next/static/media/0x5f98805a4e8be255a32880fdec7f6728c6568ba0.38635f67.svg","height":127,"width":127,"blurWidth":0,"blurHeight":0};